
export const environment = {
    production: false,

    // *** Development ***

    baseUrl: "https://infinifi-customer.public-staging.agilitygis.com/api",
    integrationUrl: 'https://integration-staging.agilitygis.com/api',
    strapiUrl: 'https://infinifi.sudosky.com',
    strapiJWTToken: 'Bearer 90f635da64a37a72717fc3bdd0bb9d3b1c78b4ea051e23a6b834771e5d47a054e06e43e289b975a8ba81a42e81612d8389c28bfb6110f72c30f4f9fad8bede6325f9904a4424f9cef5ca02d7c2c0609d42c60c84fa66d075b9d3a5a75ba6b3b6214eff305393a9bea47bfc3c7db7f1132a686349477efb3240d01d5ad7851216',
    recaptchaSiteKeyTest: '6Ld2I9QpAAAAADAclUIc6bCMfXPxb4vki2fP9It-',
    googleAnalyticsCode: 'GTM-',

    // baseUrl: "https://infinifi-customer.public.agilitygis.com/api",
    organisationId: '3543177',

    
};
